package com.milta.core.localization.translations.fr

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Annuler",
    confirm = "Confirmer",
    save = "Enregistrer",
    delete = "Supprimer",
    back = "Retour",
    loading = "Chargement…",
    retry = "Réessayer",
    creationInProgressDoNotClose = "En cours de création, ne pas fermer la fenêtre",
    processingStepSent = "Document envoyé",
    processingStepReading = "Lecture du document",
    processingStepFinding = "Repérage des livraisons",
    processingStepChecking = "Vérification des adresses",
    processingUsualDuration = "En général 20 à 40 secondes. Restez sur cet écran, nous nous occupons du reste.",
    processingLongWait = "Votre document contient beaucoup d'informations, l'analyse prend un peu plus de temps que d'habitude. Tout fonctionne, nous continuons.",
    processingInProgressSince = "En cours depuis %1",
    processingFinishedIn = "Terminée en %1",
    processingDeliveriesFound = "%1 livraisons trouvées",
    processingDeliveriesFoundOne = "1 livraison trouvée",
    processingAddressesChecked = "%1 sur %2 adresses",
    addressVerifiedBadge = "✓ Adresse vérifiée",
    addressNeedsReviewBadge = "⚠ Adresse à vérifier",
    addressFoundLine = "Trouvée : %1",
    language = "Langue",
    welcomeTitle = "Bienvenue sur Milta",
    welcomeSubtitle = "Votre assistant de tournée intelligent",
    alreadyHaveAccount = "J'ai déjà un compte",
    createAccount = "Créer un compte",
    continueWithGoogle = "Continuer avec Google",
    continueWithApple = "Continuer avec Apple",
    oauthErrorGeneric = "Une erreur est survenue lors de la connexion. Réessayez.",
    oauthAppleWebComingSoon = "La connexion avec Apple arrive bientôt sur le web.",
    oauthDriverAccountNotAllowedOnWeb = "Ce compte chauffeur ne peut pas accéder au tableau de bord web. Connectez-vous depuis l'application mobile.",
    oauthAccountNotFoundOnWeb = "Aucun compte Milta n'a été trouvé pour ce compte Google.",
    errorOffline = "Pas de connexion internet.",
    navTourneesDuJour = "Tournées du jour",
    navAjouterUneTournee = "Ajouter une tournée",
    navHistoriqueDesPreuves = "Historique des preuves",
    navParametres = "Paramètres",
    sidebarRoleManagerLabel = "Gestionnaire",
    noDeliveriesYetTitle = "Aucune livraison",
    noDeliveriesYetSubtitle = "Cliquez sur « Ajouter des livraisons » pour en ajouter",
    optimizationUnavailableExplanation = "Voulez-vous créer la tournée sans optimisation, ou réessayer ?",
    createWithoutOptimizationAction = "Créer sans optimisation",
    gpsAppSheetTitle = "Choisir une application de navigation",
    addressSearchingLabel = "Recherche en cours…",
    clearTimeFieldAction = "Effacer",
    clearTimeFieldConfirmTitle = "Effacer l'horaire ?",
    clearTimeFieldConfirmMessage = "L'horaire renseigné sera supprimé. Vous pourrez en resaisir un nouveau à tout moment.",
    updateRequiredTitle = "Mise à jour obligatoire",
    updateRequiredMessage = "Une nouvelle version de Milta est disponible. Mettez à jour l'application pour continuer à l'utiliser.",
    updateInstalledVersionLabel = "Installée",
    updateAvailableVersionLabel = "Disponible",
    updateNowButton = "Mettre à jour",
    updateDataKeptNote = "Vos tournées et livraisons sont conservées.",
    updateSendingPendingOne = "Envoi de 1 livraison validée hors ligne…",
    updateSendingPendingMany = "Envoi de {count} livraisons validées hors ligne…",
)
